<template>
  <VRow>
    <VCol col="6">
      <CandidateSliderItem v-if="prevCandidate" :candidate="prevCandidate" prev />
    </VCol>
    <VCol col="6">
      <CandidateSliderItem v-if="nextCandidate" :candidate="nextCandidate" next />
      <div v-else-if="isLoadingMore" class="candidate-slider-loader d-flex justify-center align-center">
        <VProgressCircular indeterminate color="primary" size="24" width="2" />
      </div>
    </VCol>
  </VRow>
</template>
<style lang="scss">
  .candidate-slider .v-slide-group__wrapper {
    padding: $spacer * 3;
  }
  .candidate-slider-loader {
    height: 50px;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }
</style>
<script>
import CandidateSliderItem from './CandidateSliderItem.vue';

export default {
  name: 'CandidateSlider',
  components: { CandidateSliderItem },
  props: {
    candidates: {
      type: Array,
      required: true,
    },
    candidate: {
      type: Object,
      required: true,
    },
    isLoadingMore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    prevCandidate() {
      if (this.candidates.length < 2) return null;
      const index = this.candidates.findIndex((el) => el.id === this.candidate.id);
      return index > 0 ? this.candidates[index - 1] : null;
    },
    nextCandidate() {
      if (this.candidates.length < 2) return null;
      const index = this.candidates.findIndex((el) => el.id === this.candidate.id);
      return index < this.candidates.length - 1 ? this.candidates[index + 1] : null;
    },
  },
};
</script>
